import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const TransactionsResultRow = ({ row }) => (
  <Fragment>
    {`${row.event_name} (doc: ${row.docket_no})`}
    {row.date_event_filed &&
      <div>Event Filed: {row.date_event_filed}</div>
    }
  </Fragment>
);

TransactionsResultRow.propTypes = {
  row: PropTypes.any.isRequired,
};

export default TransactionsResultRow;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/TransactionsResultRow.jsx